import * as yup from 'yup';
import { useFormHandler } from './useFormHandler';

export type PackageFormValues = {
  packageName?: string;
  packageType?: string;
  description?: string;
  price?: number;
  duration?: number;
  currency?: string;
};

const packageValidationSchema = (mode: 'create' | 'update') =>
  yup.object({
    packageName: yup
      .string()
      .when([], {
        is: () => mode === 'create',
        then: (schema) => schema.required('Veuillez saisir le nom du Package'),
        otherwise: (schema) => schema.notRequired(),
      })
      .label('PackageName'),
    packageType: yup
      .string()
      .when([], {
        is: () => mode === 'create',
        then: (schema) =>
          schema.required('Veuillez sélectionner le type du package'),
        otherwise: (schema) => schema.notRequired(),
      })
      .label('PackageType'),
    currency: yup
      .string()
      .when([], {
        is: () => mode === 'create',
        then: (schema) => schema.required('Veuillez sélectionner la divise'),
        otherwise: (schema) => schema.notRequired(),
      })
      .label('Currency'),
    description: yup
      .string()
      .when([], {
        is: () => mode === 'create',
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.notRequired(),
      })
      .label('Description'),
    price: yup
      .number()
      .transform((value, originalValue) =>
        originalValue === '' ? undefined : value,
      )
      .when([], {
        is: () => mode === 'create',
        then: (schema) =>
          schema
            .required('Veuillez saisir le prix.')
            .positive('La valeur doit être un nombre positif.'),
        otherwise: (schema) => schema.notRequired(),
      })
      .label('Price'),
    duration: yup
      .number()
      .transform((value, originalValue) =>
        originalValue === '' ? undefined : value,
      )
      .when([], {
        is: () => mode === 'create',
        then: (schema) =>
          schema
            .required('Veuillez saisir la durée.')
            .positive('La valeur doit être un nombre positif.'),
        otherwise: (schema) => schema.notRequired(),
      })
      .label('Duration'),
  });

export const useHandlePackageForm = (mode: 'create' | 'update') => {
  const { register, handleSubmit, errors, setValue, reset } =
    useFormHandler<PackageFormValues>(packageValidationSchema(mode));
  return {
    register,
    handleSubmit,
    setValue,
    errors,
    reset,
  };
};
